import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ProjectsForNavigationService } from '@efficiently/client-api-projects';

import { DefaultProjectsForNavigationService } from './default-projects-for-navigation.service';

export function provideProjectsForNavigation(): EnvironmentProviders {
	return makeEnvironmentProviders([
		{ provide: ProjectsForNavigationService, useClass: DefaultProjectsForNavigationService },
	]);
}
